import styled from 'styled-components';

export const PageContainer = styled.div`
    min-height: 100vh;
    background: #909090;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;

export const ActionButton = styled.span`
    display: block;
    padding: 10px;
    cursor: pointer;
    &:nth-child(n + 2) {
        margin-left: 10px;
    }
`;

export const TSLoaderWrap = styled.div`
    display: flex;
    min-height: 100vh;
    background-color: #2c3944;
`;

export const Wrapper = styled.div`
    padding: 10px;
    @media (min-width: 770px) {
        padding-top: 30px;
    }
`;

export const Greeting = styled.h1`
    width: 100%;
    padding: 50px 20px 90px;
    text-align: center;
    font-family: Montserrat;
    font-size: 32px;
    box-sizing: border-box;
    span {
        text-transform: capitalize;
    }
`;

export const Container = styled.div`
    max-width: 350px;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #fafafa;
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    @media (min-width: 770px) {
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
        max-width: 700px;
        margin: 0 auto;
    }
`;

export const Head = styled.div`
    padding: 25px 0px 20px 0px;
    background-color: #2c3944;
    @media (min-width: 770px) {
        width: 100%;
    }
    img {
        max-width: 60%;
        max-height: 30%;
        @media (min-width: 770px) {
            width: 269px;
            height: 56px;
        }
    }
`;

export const Title = styled.h1`
    box-sizing: border-box;
    margin-bottom: 12px;
    text-align: center;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 200;
    font-size: 45px;
    line-height: 55px;
    text-align: center;
    color: #4b5259;
    span {
        text-transform: capitalize;
    }
`;

export const Subtitle = styled.p`
    box-sizing: border-box;
    margin-bottom: 12px;
    text-align: center;
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    text-transform: uppercase;
    color: #70757a;
    font-display: optional;
`;

export const InnerContainer = styled.div`
    box-sizing: border-box;
    padding: 15px;
    @media (min-width: 770px) {
        display: flex;
        justify-content: space-between;
        /* min-height: 378px; */
        margin: 0 auto 48px;
        padding: 15px;
    }
`;

export const Form = styled.form`
    box-sizing: border-box;
    @media (min-width: 770px) {
        width: 335px;
        padding: 15px;
    }
    &:nth-child(1) {
        @media (min-width: 770px) {
            box-shadow: 0 1px 1px rgba(0, 0, 0, 0);
        }
    }
`;

export const InnerTitle = styled.h5`
    font-family: 'Arial';
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    padding-top: 10px;
    padding-bottom: 12px;
    color: #3b3b3b;
    margin: 0;
    font-display: optional;
`;

export const Label = styled.label`
    font-size: 14px;
    line-height: 1.42857143;
    font-family: 'Arial';
    color: #3b3b3b;
    box-sizing: border-box;
    display: inline-block;
    max-width: 100%;
    margin-bottom: 6px;
    font-weight: 400;
    font-display: optional;
`;

export const Input = styled.input`
    box-sizing: border-box;
    margin: 0;
    font-family: 'Arial' !important;
    font-family: inherit;
    display: block;
    padding: 6px 12px;
    font-size: 16px;
    line-height: 1.42857143;
    background-image: none;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    width: 100%;
    height: 37px;
    color: #555;
    background-color: #fff;
    border: 1px solid rgba(34, 36, 38, 0.15);
    outline: none;
    @media (min-width: 770px) {
        font-size: 14px;
    }
    font-display: optional;
`;

export const BlueButton = styled.button.attrs({ type: 'button' })`
    display: block;
    font-size: 15px;
    line-height: 1.42857143;
    font-family: 'Arial';
    color: #337ab7;
    margin: 0;
    padding: 0;
    background: transparent;
    border: none;
    box-sizing: border-box;
    display: inline-block;
    max-width: 100%;
    /* margin-bottom: 6px; */
    font-weight: 400;
    cursor: pointer;
    outline: none;
    font-display: optional;
`;

export const SubmitButton = styled.button`
    box-sizing: border-box;
    font: inherit;
    font-family: inherit;
    display: inline-block;
    padding: 6px 12px;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
    border-color: rgb(0, 179, 87);
    font-family: Arial;
    font-size: 14px;
    font-weight: bold;
    margin: 17px 0px 10px 0px;
    height: 40px;
    width: 100%;
    color: #fff;
    background-color: rgb(0, 179, 87);
    -webkit-appearance: button;
    cursor: pointer;
    outline: none;
    &:hover {
        color: #fff;
        background-color: rgb(0, 179, 87);
    }
    &:active {
        color: #fff;
        background-color: rgb(0, 179, 87);
        border-color: rgb(0, 179, 87);
    }
    &:disabled {
        opacity: 0.7;
        &:hover,
        &:active {
            color: #fff;
            background-color: rgb(0, 179, 87);
        }
    }
    font-display: optional;
`;

export const TextWrapper = styled.span`
    display: flex;
    justify-content: center;
    align-items: baseline;
    margin: 0 auto 10px;
    text-align: center;
    @media (min-width: 770px) {
        margin: 0 auto 20px;
    }
    button {
        margin: 0 5px;
    }
    font-display: optional;
`;

export const Text = styled.span`
    font-size: 14px;
    line-height: 1.42857143;
    font-family: 'Arial';
    color: #3b3b3b;
    box-sizing: border-box;
    display: inline-block;
    max-width: 100%;
    /* margin-bottom: 6px; */
    font-weight: 400;
    font-display: optional;
`;

export const LoaderWrap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .spinner {
        width: 25px;
        height: 25px;
    }
    .spinner::before,
    .spinner::after {
        top: 0;
        left: 0;
        width: 20px;
        height: 20px;
        margin: 0;
        border-radius: 50%;
        border-width: 4px;
        border: 2px solid rgba(255, 255, 255, 0.3);
    }
    .spinner::after {
        border-color: white transparent transparent;
    }
    font-display: optional;
`;

export const BigLoaderWrap = styled.div`
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
    .spinner {
        width: 90px;
        height: 90px;
    }
    .spinner::before,
    .spinner::after {
        top: 0;
        left: 0;
        width: 80px;
        height: 80px;
        margin: 0;
        border-radius: 50%;
        border-width: 4px;
        border: 5px solid rgba(0, 0, 0, 0.3);
    }
    .spinner::after {
        border-color: rgba(0, 0, 0, 0.5) transparent transparent;
    }
    font-display: optional;
`;

export const SocialLoaderWrap = styled.div`
    width: 100%;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    .spinner {
        width: 51px;
        height: 51px;
    }
    .spinner::before,
    .spinner::after {
        top: 0;
        left: 0;
        width: 45px;
        height: 45px;
        margin: 0;
        border-radius: 50%;
        border-width: 4px;
        border: 3px solid rgba(0, 0, 0, 0.3);
    }
    .spinner::after {
        border-color: rgba(0, 0, 0, 0.5) transparent transparent;
    }
    font-display: optional;
`;

export const Error = styled.p`
    line-height: 1.42857143;
    font-family: 'Arial';
    box-sizing: border-box;
    margin: 0 0 10px;
    padding: 10px 12px;
    font-size: 14px;
    width: 100%;
    background: #fff6f6;
    border: 1px solid #e0b4b4;
    color: #d29f9f;
    font-display: optional;
`;

export const SocialWrap = styled.div`
    @media (min-width: 770px) {
        width: 302px;
    }
`;

export const GoogleButton = styled.button`
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    margin: 0;
    font: inherit;
    overflow: visible;
    text-transform: none;
    -webkit-appearance: button;
    display: block;
    font-size: 14px;
    line-height: 1.42857143;
    white-space: nowrap;
    touch-action: manipulation;
    cursor: pointer;
    user-select: none;
    border: 1px solid transparent;
    border-radius: 2px;
    padding: 1px;
    height: 40px;
    text-align: left;
    width: 100%;
    margin-bottom: 15px;
    background: #4285f4;
    color: #fff;
    font-family: Roboto, 'Helvetica Neue', Arial, sans-serif;
    font-weight: 500;
    &:hover {
        background: #3f7ce8;
        color: #eee;
    }
    &:active {
        background: #4285f4;
        font-weight: 500;
    }
    &:disabled {
        opacity: 0.7;
        &:hover,
        &:active {
            color: #fff;
            background-color: #4285f4;
        }
    }
    span {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        font: inherit;
        text-transform: none;
        font-size: 14px;
        line-height: 1.42857143;
        white-space: nowrap;
        cursor: pointer;
        user-select: none;
        text-align: left;
        color: #fff;
        font-family: Roboto, 'Helvetica Neue', Arial, sans-serif;
        font-weight: 500;
        box-sizing: border-box;
    }
    svg {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        font: inherit;
        text-transform: none;
        font-size: 14px;
        line-height: 1.42857143;
        white-space: nowrap;
        cursor: pointer;
        user-select: none;
        color: #fff;
        font-family: Roboto, 'Helvetica Neue', Arial, sans-serif;
        font-weight: 500;
        box-sizing: border-box;
        overflow: hidden;
        display: inline-block;
        height: 100%;
        margin-right: 12px;
        padding: 9px;
        text-align: center;
        vertical-align: middle;
        background: #fff;
        border-radius: 2px;
    }
    font-display: optional;
`;

export const FacebookButton = styled.button`
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    margin: 0;
    font: inherit;
    overflow: visible;
    text-transform: none;
    -webkit-appearance: button;
    font-family: inherit;
    display: inline-block;
    font-size: 14px;
    line-height: 1.42857143;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 2px;
    height: 40px;
    margin-bottom: 15px;
    padding: 1px;
    text-align: left;
    width: 100%;
    background-color: #4267b2;
    color: white;
    font-weight: 600;
    &:hover {
        background-color: #2955ad;
        color: white;
    }
    &:active {
        background: #4285f4;
        font-weight: 500;
    }
    &:disabled {
        opacity: 0.7;
        &:hover,
        &:active {
            color: #fff;
            background-color: #4285f4;
        }
    }
    span {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        font: inherit;
        text-transform: none;
        font-size: 14px;
        line-height: 1.42857143;
        white-space: nowrap;
        cursor: pointer;
        user-select: none;
        text-align: left;
        color: #fff;
        font-family: Roboto, 'Helvetica Neue', Arial, sans-serif;
        font-weight: 500;
        box-sizing: border-box;
        font-display: optional;
    }
    svg {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        font: inherit;
        text-transform: none;
        font-family: inherit;
        font-size: 14px;
        line-height: 1.42857143;
        white-space: nowrap;
        cursor: pointer;
        user-select: none;
        font-weight: 600;
        color: rgb(255, 255, 255);
        box-sizing: border-box;
        overflow: hidden;
        display: inline-block;
        height: 100%;
        margin-right: 12px;
        text-align: center;
        vertical-align: middle;
        padding: 6px;
        font-display: optional;
    }
`;

export const Divider = styled.div`
    position: relative;
    font-size: 16px;
    padding: 7px 0;
    margin-top: 8px;
    @media (min-width: 770px) {
        padding: 15px 0;
    }
    hr {
        margin: 0;
        @media (min-width: 770px) {
            display: block;
            width: 1px;
            height: 100%;
            border: none;
            background-color: rgba(0, 0, 0, 0.05);
        }
    }
    span {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        line-height: 1.42857143;
        font-family: 'Arial';
        font-size: 16px;
        box-sizing: border-box;
        display: block;
        position: absolute;
        left: 50%;
        top: -4px;
        margin-left: -12px;
        text-align: center;
        padding: 0px 5px 0px 5px;
        color: #a3a3a3;
        background-color: #fafafa;
        @media (min-width: 770px) {
            top: calc(50% - 26px);
            margin-top: -11px;
            margin-left: -7px;
            padding: 15px 0;
        }
        font-display: optional;
    }
`;

export const SmallText = styled.span`
    display: block;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    line-height: 1.42857143;
    font-family: 'Arial';
    box-sizing: border-box;
    color: #747474;
    font-size: 11px;
    font-display: optional;
`;
